module.exports = __webpack_public_path__ + "media/images/common/ico-lp-toggle-5744eff078c90e71c6d54eecc61c60c2.svg";